"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _Errors = _interopRequireDefault(require("./Errors"));

var _Input = _interopRequireDefault(require("../../elements/Input"));

var _Label = _interopRequireDefault(require("../../elements/Label"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var FieldLabel = function FieldLabel(_ref) {
  var name = _ref.name,
      optional = _ref.optional,
      children = _ref.children;
  return React.createElement(_Label.default, {
    htmlFor: name
  }, children, optional && React.createElement("span", {
    className: "optional"
  }, "(Optional)"));
};

var FieldDescription = function FieldDescription(_ref2) {
  var children = _ref2.children;
  return React.createElement("div", {
    className: "field-description"
  }, children);
};

var componentOrDefault = function componentOrDefault(child, props, DefaultChild) {
  if (child || child === "") {
    if (typeof child === "string") {
      return React.createElement(DefaultChild, null, child);
    } else {
      return child(props);
    }
  }

  return null;
};

var renderInput = function renderInput(passProps) {
  return React.createElement(_Input.default, passProps);
};

var Field =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Field, _React$Component);

  function Field() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Field);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Field)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      focus: false
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleFocus", function (e) {
      _this.setState({
        focus: true
      });

      _this.props.onFocus && _this.props.onFocus(e);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleBlur", function (e) {
      _this.setState({
        focus: false
      });

      _this.props.onBlur && _this.props.onBlur(e);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleChange", function (value, e) {
      // If the onChange is a normal onChange, value will be our event, and we should extract
      // the value
      if (e === undefined && (value instanceof Event || value.nativeEvent)) {
        e = value;
        var _value = value,
            currentTarget = _value.currentTarget;
        value = currentTarget ? currentTarget.value : undefined;
      }

      _this.props.onChange && _this.props.onChange(value, e);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderChildren", function (children, passProps) {
      return React.isValidElement(children) ? children : children(passProps);
    });

    return _this;
  }

  _createClass(Field, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          name = _this$props.name,
          _this$props$id = _this$props.id,
          id = _this$props$id === void 0 ? name : _this$props$id,
          label = _this$props.label,
          _this$props$variant = _this$props.variant,
          variant = _this$props$variant === void 0 ? "primary" : _this$props$variant,
          optional = _this$props.optional,
          errors = _this$props.errors,
          description = _this$props.description,
          _this$props$className = _this$props.className,
          className = _this$props$className === void 0 ? '' : _this$props$className,
          _this$props$children = _this$props.children,
          children = _this$props$children === void 0 ? renderInput : _this$props$children,
          _this$props$disabled = _this$props.disabled,
          disabled = _this$props$disabled === void 0 ? false : _this$props$disabled,
          placeholder = _this$props.placeholder,
          type = _this$props.type,
          value = _this$props.value,
          forwardRef = _this$props.forwardRef,
          props = _objectWithoutProperties(_this$props, ["name", "id", "label", "variant", "optional", "errors", "description", "className", "children", "disabled", "placeholder", "type", "value", "forwardRef"]);

      var focus = this.state.focus;
      var hasErrors = errors && errors.length;

      var passProps = _extends({
        name: name,
        id: id
      }, props, {
        ref: forwardRef,
        className: hasErrors ? 'errors' : undefined,
        value: value,
        type: type,
        variant: variant,
        placeholder: placeholder || label,
        disabled: disabled,
        onChange: this.handleChange,
        onBlur: this.handleBlur,
        onFocus: this.handleFocus
      });

      var properties = {
        name: name,
        value: value,
        errors: errors,
        focused: focus,
        disabled: disabled,
        optional: optional
      };
      var labelElement = componentOrDefault(label, properties, FieldLabel);
      var descriptionElement = componentOrDefault(description, properties, FieldDescription);
      return React.createElement("div", {
        key: name,
        className: "Fulcrum Field variant-".concat(variant, " ").concat(className, " field-").concat(name, " ").concat(focus ? 'focus' : '', " ").concat(hasErrors ? 'errors' : '')
      }, labelElement, React.createElement("div", {
        className: "field-content"
      }, React.createElement("div", {
        className: "field"
      }, this.renderChildren(children, passProps)), React.createElement(_Errors.default, {
        errors: errors,
        name: name
      }), descriptionElement));
    }
  }]);

  return Field;
}(React.Component);

var _default = React.forwardRef(function (props, ref) {
  return React.createElement(Field, _extends({}, props, {
    forwardRef: ref
  }));
});

exports.default = _default;